import Backbone from 'backbone'
import 'underscore'
import 'backbone.marionette.lib'

export default Backbone.Marionette
